import * as React from 'react';

const DownArrowIcon = ({ width = 16, height = 10 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M13.671.83a1.036 1.036 0 0 1 1.515 0 1.163 1.163 0 0 1 0 1.59L8.758 9.17c-.419.44-1.097.44-1.516 0L.814 2.42a1.165 1.165 0 0 1 0-1.59 1.036 1.036 0 0 1 1.515 0L8 6.784 13.671.83Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};
export default DownArrowIcon;
